import cacheManager from './cache-manager';
import store from './store';
import status from './status';
import queueStore from './queue-store';
import downloadStore from './download-store';

export default {
  cacheManager,
  store,
  status,
  queueStore,
  downloadStore
}
